import 'normalize.css' // Import normalize.css to override browser default styles for consistency
import Typewriter from 'typewriter-effect/dist/core' // Import typewriter-effect for animated text about what Moon Swap is
import _ from 'lodash' // Import lodash for utility functions
import { scaleLinear } from 'd3-scale' // Import linear scale from d3-scale for scaling values
import mediumZoom from 'medium-zoom' // Import medium-zoom for zooming images on click

// Hiiiiiiiiiiiiiiiiiiiiiii
console.log('Hiiiiiiii 🌝')

// Allows :active css styles to display properly on mobile
document.addEventListener("touchstart", function(){}, true)

// Rotate what is a moon swap text
let wtfisamoonswapTexts = [
    'Think of it as a free night market, or a potluck where we share more than just food.',
    'A container for community for community care.',
    'An actually free free market.',
    'A mutual aid potluck.',
    'Chuck E. Cheese for transit oriented teens.',
    'Replacing currency with context.',
    'A library with no due dates.',
    'From each according to their whim, to each according to their wildest dream.',
    'A gathering for abundance.',
    'A gathering against transactionality.',
    'A collective for collective liberation.',
    'A mutual aid potluck.',
    'Free luxury.'
]
wtfisamoonswapTexts = _(wtfisamoonswapTexts).shuffle()
new Typewriter('#wtfisamoonswap', {
  strings: wtfisamoonswapTexts,
  autoStart: true,
  delay: 50,
  pauseFor: 2500
})

// === ✨ Moon Phases ✨ ===
const theMoon = document.getElementById('the-moon')
import { Moon } from "lunarphase-js"
theMoon.innerText = Moon.lunarPhaseEmoji()
// Add to page <title> replacing the first character with the current moon phase emoji
document.title = document.title.replace(/../, theMoon.innerText) // TODO: This is a hacky way to replace the first character, consider using a more robust method if needed

// Length of time to show stars, converted from days to a % of the lunar cycle
const starDuration = 3/29.53059

let moonPhase = (customPhase) => {
    // Limit customPhase to a value between 0 and 1
    if (customPhase < 0 || customPhase > 1) {
        console.warn('Custom phase must be between 0 and 1, using current moon phase instead.')
        customPhase = null
    }

    // If customPhase is provided and valid, use it, otherwise use the current moon phase
    let phase = customPhase || Moon.lunarAgePercent()
    if (customPhase === 0) phase = customPhase // Handle the case where customPhase is exactly 0
    console.log('moonPhase called with phase:', phase)

    // Reset background style and dark theme to default
    document.body.style.backgroundColor = ''
    document.body.classList.remove('dark-theme')
    document.body.classList.remove('swap-theme')

    // Case: 0 to (0.5 - starDuration/2)
    if (phase < 0.5 - starDuration / 2) {
        console.log('Phase is waxing.')

        // Subcase: 0 to (0.5-starDuration/2)/2
        if (phase < (0.5 - starDuration / 2) / 2) {
            console.log('In first half of waxing phase')

            // Set custom background color 
            let lightness =
                scaleLinear()
                    .domain([0, (0.5 - starDuration / 2) / 2])
                    .range([100, 64])(phase)
            console.log('Setting lightness to:', lightness)
            document.body.style.backgroundColor = 'hsl(53, 4%, ' + lightness + '%)'
        }

        // Subcase: (0.5-starDuration/2)/2 to (0.5-starDuration/2)
        else {
            console.log('In second half of waxing phase')

            // Set page theme overall
            document.body.classList.add('dark-theme')

            // Set custom background color
            let lightness =
                scaleLinear()
                    .domain([(0.5 - starDuration / 2) / 2, 0.5 - starDuration / 2])
                    .range([37, 10])(phase)
            console.log('Setting lightness to:', lightness)
            document.body.style.backgroundColor = 'hsl(53, 7%, ' + lightness + '%)'
        }

    }

    // Case: above (0.5 - starDuration/2) to below (0.5 + starDuration/2)
    else if (phase >= 0.5 - starDuration / 2 && phase < 0.5 + starDuration / 2) {
        console.log('Phase is MOON SWAP.')
        
        // Switch to dark theme
        document.body.classList.add('swap-theme')

        // Show stars
        theMoon.classList.add('show-stars')
    }

    // Case: (0.5 + starDuration/2) to 1
    else if (phase >= 0.5 + starDuration / 2 && phase < 1) {
        console.log('Phase is waning. Mapping the current waning phase to a waxing phase for display purposes, and calling moonPhase() with that value.')
        moonPhase(
            scaleLinear()
                .domain([0.5 + starDuration / 2, 1])
                .range([0.5 - starDuration / 2, 0])
            (phase)
        )
    }
}

// Initial call to set the moon phase based on the current lunar phase
moonPhase()

// Update slider and text with the current moon phase
let day = 'Day ' + Math.round(Moon.lunarAge())
document.getElementById('myRange').value = Math.round(
    scaleLinear()
        .domain([1, 29.53059]) // Convert to a value between 0 and 100
        .range([0, 100])
        (Moon.lunarAge())
)
document.getElementById('moon-phase-value').innerText = day

// Allow slider to set custom moon phase
document.getElementById('myRange').oninput = function(event) {
    // Get the value of the slider
    let value = event.target.value // Convert to a value between 0 and 1
    console.log('Slider value:', value)

    // Update the displayed value
    document.getElementById('moon-phase-value')
        .innerText = 'Day ' +
        Math.round(
            scaleLinear()
                .domain([0, 100])
                .range([1, 29.53059]) // Convert to days in the lunar cycle
                (value)
        )

    // Call moonPhase with the slider value scaled to a 0-1 range
    moonPhase(value / 100)
}

// Initialize medium-zoom for images with the class 'zoomable'
mediumZoom('[data-zoomable]', {
    background: '#000'
})